<ng-container *ngIf="href">
  <iframe [src]="href | safeUrl" allow="accelerometer; gyroscope" frameBorder="0"></iframe>
</ng-container>